import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme)=>({
    errorImageBox:{
        '&.MuiBox-root':{
            backgroundColor:'white',
            display:'flex',
            justifyContent:'center', 
            alignItems:'center',
            flexDirection:'column',
            textAlign:'center',
            height:'100vh'
        }
    },
    errorImage: {
        maxWidth: '25%', 
        height: 'auto',  
        marginBottom: '40px',
        border:'1px solid transparent',
        borderRadius:'50px',
        padding:'40px',
        boxShadow: '0px 0px 63px -16px rgba(143,112,177,1)',
        // [theme.breakpoints.down("md")]:{
        //     maxWidth: '30%', 
        // },
        // [theme.breakpoints.down("sm")]:{
        //     maxWidth: '50%', 
        // },
    },
    noInternetImage:{
        maxWidth: '25%', 
        height: 'auto',  
        border:'1px solid transparent',
        borderRadius:'50px',
        padding:'25px',
        boxShadow: '0px 0px 63px -16px rgba(143,112,177,1)',
        borderRadius:'50px',
        marginBottom: '40px',
        // [theme.breakpoints.down("md")]:{
        //     maxWidth: '35%', 
        // },
        // [theme.breakpoints.down("sm")]:{
        //     maxWidth: '60%', 
        // }, 
    },
    errorTextGrid:{
        '& .MuiGrid-root':{
            // [theme.breakpoints.down("sm")]:{
            //     padding:'0 20px',
            // }
        }
    },
    errorHeading:{
        '&.MuiTypography-h5':{
            color:'#8f70b1',
            fontWeight:'600',
            margin:'10px 0',
        }
    },
    errorBody:{
        '&.MuiTypography-body1':{
            fontWeight:'500',
        }
    }
}));

export default useStyles;